module.exports = __webpack_public_path__ + "static/media/logo.287f7248.svg";